module.exports = __webpack_public_path__ + "static/img/sx1.4f3bb4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/sx/sx1.png
// module id = 1Psb
// module chunks = 0